// extracted by mini-css-extract-plugin
module.exports = {"error_block":"styles_error_block__lRCK6"};